import { useState, type MouseEvent } from 'react';
import { KURS_QUELLE_NAMEN, PROJEKT_WAEHRUNG, betrag, kursText, type BelegAnsicht } from '@beholder/shared/module/budget';
import { datum } from '../../core/ui';

const beruehrung = () => typeof window !== 'undefined' && window.matchMedia?.('(hover: none)').matches;

/**
 * Hauptbetrag eines Belegs – immer in Euro (Marc). War der Beleg in einer anderen Währung, erscheint der
 * Originalbetrag beim Überfahren mit der Maus darüber; am Handy durch Antippen.
 * `netto`: Nettobetrag statt brutto zeigen.
 */
export function Euro({ b, netto, klasse, fokus }: { b: BelegAnsicht; netto?: boolean; klasse?: string; fokus?: boolean }) {
  const [offen, setOffen] = useState(false);
  const euro = netto ? b.umgerechnetNettoCent : b.umgerechnetCent;
  const haupt = euro === null ? 'kein Kurs' : betrag(euro, PROJEKT_WAEHRUNG);
  const ersatz = b.kursQuelle === 'ersatz';
  if (b.waehrung === PROJEKT_WAEHRUNG) return <span className={klasse}>{haupt}</span>;

  const original = betrag(netto ? b.nettoCent : b.betragCent, b.waehrung);
  const kurs = b.kurs ? `${kursText(b.kurs, b.waehrung, PROJEKT_WAEHRUNG)}${b.kursDatum ? ` vom ${datum(b.kursDatum)}` : ''}` : 'noch kein Kurs';
  const tippen = (e: MouseEvent) => {
    if (!beruehrung()) return;
    // Am Handy: Antippen zeigt das Original (statt den Beleg zu öffnen)
    e.stopPropagation();
    e.preventDefault();
    setOffen((x) => !x);
  };
  return (
    <span
      className={`bu-euro${offen ? ' offen' : ''}${euro === null ? ' bu-text-warn' : ''}${klasse ? ` ${klasse}` : ''}`}
      onClick={tippen}
      onMouseLeave={() => setOffen(false)}
      tabIndex={fokus ? 0 : undefined}
      onBlur={() => setOffen(false)}
      aria-label={`${haupt}, Original ${original}`}
    >
      <span className="bu-euro-blase" role="tooltip">
        <strong>{original}</strong>
        <span>
          {kurs}
          {b.kurs && ` · ${KURS_QUELLE_NAMEN[b.kursQuelle]}`}
        </span>
      </span>
      {haupt}
      {ersatz && <span title="Ersatzkurs – die Kursquelle war nicht erreichbar"> *</span>}
    </span>
  );
}
